import axios from 'axios';
import { configPara } from '../../components/globalComponents/APIUrlConfig';

const CLEAR_DATA = 'CLEAR_DATA';
const LOAD_BANNERS = 'LOAD_BANNERS';
const LOAD_BANNERS_ERROR = 'LOAD_BANNERS_ERROR';
const apiUrl = configPara.url.concat('/banners');

export const clearData = () => ({
  type: CLEAR_DATA,
});

export const banners = (payload) => ({
  type: LOAD_BANNERS,
  payload,
});

export const bannersError = (error) => ({
  type: LOAD_BANNERS_ERROR,
  payload: error,
});

export const fetchBanners = () => {
  return (dispatch, getState) => {
    const state = getState().bannersResult; // ✅ corrected
    if (state?.bannersResult?.length > 0) {
      return;
    }

    return axios
      .get(apiUrl, {auth: configPara.auth})
      .then((response) => {
        dispatch(banners(response.data?.banners || []));
      })
      .catch((error) => {
        dispatch(bannersError(error.message || 'Failed to fetch banners'));
        console.error(error);
      });
  };
};
